import { gql } from '@apollo/client';
import type { FleetGeofenceRecommendation, RecommendationActionResult } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLGeofenceRecommendationsRequester {
  public generateFleetGeofenceRecommendations = (fleetId: string): Promise<FleetGeofenceRecommendation[]> => {
    return graphQLRequester
      .mutate<{ generateFleetGeofenceRecommendations: FleetGeofenceRecommendation[]; errors: Array<any> }>({
        mutation: gql`
          mutation GenerateFleetGeofenceRecommendations($fleetId: ID!) {
            generateFleetGeofenceRecommendations(fleetId: $fleetId) {
              id
              fleetId
              name
              reason
              address
              color
              type
              area
              format
              radius
              longitude
              latitude
            }
          }
        `,
        variables: { fleetId },
      })
      .then((result) => {
        if (result.errors?.length) {
          throw new Error(`GraphQL mutation errors: ${result.errors.map((e) => e.message).join(', ')}`);
        }
        return result.generateFleetGeofenceRecommendations;
      });
  };

  public completeFleetRecommendation = (fleetId: string, id: string): Promise<RecommendationActionResult> => {
    return graphQLRequester
      .mutate<{ completeFleetRecommendation: RecommendationActionResult; errors: Array<any> }>({
        mutation: gql`
          mutation CompleteFleetRecommendation($fleetId: ID!, $id: ID!) {
            completeFleetRecommendation(fleetId: $fleetId, category: "POIS", id: $id) {
              id
              fleetId
              finishedAt
              dismissedAt
              completedBy
            }
          }
        `,
        variables: { fleetId, id },
      })
      .then((result) => {
        if (result.errors?.length) {
          throw new Error(`GraphQL mutation errors: ${result.errors.map((e) => e.message).join(', ')}`);
        }
        return result.completeFleetRecommendation;
      });
  };

  public dismissFleetRecommendation = (fleetId: string, id: string): Promise<RecommendationActionResult> => {
    return graphQLRequester
      .mutate<{ dismissFleetRecommendation: RecommendationActionResult; errors: Array<any> }>({
        mutation: gql`
          mutation DismissFleetRecommendation($fleetId: ID!, $id: ID!) {
            dismissFleetRecommendation(fleetId: $fleetId, category: "POIS", id: $id) {
              id
              fleetId
              finishedAt
              dismissedAt
              completedBy
            }
          }
        `,
        variables: { fleetId, id },
      })
      .then((result) => {
        if (result.errors?.length) {
          throw new Error(`GraphQL mutation errors: ${result.errors.map((e) => e.message).join(', ')}`);
        }
        return result.dismissFleetRecommendation;
      });
  };
}

export default GraphQLGeofenceRecommendationsRequester;
